import _ from 'lodash'

const podcasts = (state) => _.get(state, 'podcasts')
const podcastNumber = (state) => _.get(state, 'podcastNumber')
const loading = (state) => _.get(state, 'isLoading')
const currentPodcast = (state) => _.get(state, 'currentPodcast')
const playlist = (state) => _.get(state, 'playlist')
const play = (state) => _.get(state, 'play')

export default {
    podcasts,
    podcastNumber,
    loading,
    currentPodcast,
    playlist,
    play
}
